import React from 'react';
import { withRouter } from 'react-router-dom';
import CadastrarOrcamentoForm from './CadastrarOrcamentoForm.jsx';
import CadastrarOrcamentoConf from './CadastrarOrcamentoConf.jsx';

class CadastrarOrcamento extends React.Component {

    constructor() {

        super();

        this.state = {
            disabled: false,
            centroId: 0,
            centro: "",
            id: 0,
            codConta: "",
            conta: "",
            tipoConta: "",
            tipoContaNome: "",
            naturezaConta: "",
            cultura: "",
            ano: "",
            janeiro: "0,00",
            fevereiro: "0,00",
            marco: "0,00",
            abril: "0,00",
            maio: "0,00",
            junho: "0,00",
            julho: "0,00",
            agosto: "0,00",
            setembro: "0,00",
            outubro: "0,00",
            novembro: "0,00",
            dezembro: "0,00",
            comentario: "",
            total: "0,00",
            conf: false
        };

        this.changeAno = this.changeAno.bind(this);
        this.changeJaneiro = this.changeJaneiro.bind(this);
        this.changeFevereiro = this.changeFevereiro.bind(this);
        this.changeMarco = this.changeMarco.bind(this);
        this.changeAbril = this.changeAbril.bind(this);
        this.changeMaio = this.changeMaio.bind(this);
        this.changeJunho = this.changeJunho.bind(this);
        this.changeJulho = this.changeJulho.bind(this);
        this.changeAgosto = this.changeAgosto.bind(this);
        this.changeSetembro = this.changeSetembro.bind(this);
        this.changeOutubro = this.changeOutubro.bind(this);
        this.changeNovembro = this.changeNovembro.bind(this);
        this.changeDezembro = this.changeDezembro.bind(this);
        this.changeComentario = this.changeComentario.bind(this);
        this.calcularTotal = this.calcularTotal.bind(this);
        this.cadastrar = this.cadastrar.bind(this);
        this.cancelar = this.cancelar.bind(this);
        this.voltar = this.voltar.bind(this);
        this.confirmar = this.confirmar.bind(this);

    }

    desformatarValor(s) {
        if (s === null) return "";
        return s.replace(",", ".");
    }

    formatarValor(s) {
        if (s === null || s === "") return "";
        return parseFloat(this.desformatarValor(s)).toFixed(2).replace(".", ",");
    }

    formatarTotal(s) {
        if (s === null || s === "") return "";
        return s.toFixed(2).replace(".", ",");
    }

    moneyMask(str_val) {

        let res = ""; 
        let vec = str_val.split(".");
        let c = 0;

        for (let i = vec[0].length - 1; i >= 0; i--) {

            if (c !== 0 && c % 3 === 0 && vec[0][i] !== "-") {
                res = vec[0][i] + "." + res;
            } else {
                res = vec[0][i] + res;
            }

            c++;

        }

        if (vec[1] !== undefined) {

            if (vec[1].length === 1)  res = res + "," + vec[1] + "0";
            else res = res + "," + vec[1];

        } else {
            res = res + ",00";
        }

        return res;

    }

    moneyUnmask(str_val) {

        let res = ""; 
        let vec = str_val.split(",");

        for (let i = 0; i < vec[0].length; i++) {

            if (vec[0][i] !== ".") {
                res = res + vec[0][i];
            }

        }

        res = res + "." + vec[1];
        return res;

    }

    dynamicMoneyMask(str_val) {

        let sval = "";
        let re = /^(-|[0-9])$/i;
        let neg = false;

        if (str_val !== "-0,0") {

            for (let i = 0; i < str_val.length; i++) {

                if (re.test(str_val[i])) {

                    if (str_val[i] === "-") neg = true;
                    else sval = sval + str_val[i];

                }

            }

        }

        sval = parseInt(sval);
        sval = sval.toString();
        let res = "";

        if (sval === "NaN") {

            res = "0,00";

        } else if (sval.length === 1) {

            res = "0,0" + sval;

        } else if (sval.length === 2) {

            res = "0," + sval;

        } else {

            let i = sval.length - 1;
            let c = 0;

            res = sval[i] + res;
            i--;

            res = sval[i] + res;
            i--;

            res = "," + res;

            for (; i >= 0; i--) {

                if (c !== 0 && c % 3 === 0) {
                    res = sval[i] + "." + res;
                } else {
                    res = sval[i] + res;
                }

                c++;

            }

        }

        if (neg) {
            res = "-" + res;
        }

        return res;

    }

    changeAno(e) {

        let re = /^[0-9]*$/i;

        if (re.test(e.target.value)) {
            this.setState({ ano: e.target.value });
        }

    }

    changeJaneiro(e) {

        /*let re = /^-?[0-9]*(,[0-9]{0,2})?$/i;

        if (re.test(e.target.value)) {
            this.setState({ janeiro: e.target.value });
            this.calcularTotal(e.target.value, 1);
        }*/

        let dmm = this.dynamicMoneyMask(e.target.value);

        this.setState({ janeiro: dmm });
        this.calcularTotal(dmm, 1);

    }

    changeFevereiro(e) {

        /*let re = /^-?[0-9]*(,[0-9]{0,2})?$/i;

        if (re.test(e.target.value)) {
            this.setState({ fevereiro: e.target.value });
            this.calcularTotal(e.target.value, 2);
        }*/

        let dmm = this.dynamicMoneyMask(e.target.value);

        this.setState({ fevereiro: dmm });
        this.calcularTotal(dmm, 2);

    }

    changeMarco(e) {

        /*let re = /^-?[0-9]*(,[0-9]{0,2})?$/i;

        if (re.test(e.target.value)) {
            this.setState({ marco: e.target.value });
            this.calcularTotal(e.target.value, 3);
        }*/

        let dmm = this.dynamicMoneyMask(e.target.value);

        this.setState({ marco: dmm });
        this.calcularTotal(dmm, 3);

    }

    changeAbril(e) {

        /*let re = /^-?[0-9]*(,[0-9]{0,2})?$/i;

        if (re.test(e.target.value)) {
            this.setState({ abril: e.target.value });
            this.calcularTotal(e.target.value, 4);
        }*/

        let dmm = this.dynamicMoneyMask(e.target.value);

        this.setState({ abril: dmm });
        this.calcularTotal(dmm, 4);

    }

    changeMaio(e) {

        /*let re = /^-?[0-9]*(,[0-9]{0,2})?$/i;

        if (re.test(e.target.value)) {
            this.setState({ maio: e.target.value });
            this.calcularTotal(e.target.value, 5);
        }*/

        let dmm = this.dynamicMoneyMask(e.target.value);

        this.setState({ maio: dmm });
        this.calcularTotal(dmm, 5);

    }

    changeJunho(e) {

        /*let re = /^-?[0-9]*(,[0-9]{0,2})?$/i;

        if (re.test(e.target.value)) {
            this.setState({ junho: e.target.value });
            this.calcularTotal(e.target.value, 6);
        }*/

        let dmm = this.dynamicMoneyMask(e.target.value);

        this.setState({ junho: dmm });
        this.calcularTotal(dmm, 6);

    }

    changeJulho(e) {

        /*let re = /^-?[0-9]*(,[0-9]{0,2})?$/i;

        if (re.test(e.target.value)) {
            this.setState({ julho: e.target.value });
            this.calcularTotal(e.target.value, 7);
        }*/

        let dmm = this.dynamicMoneyMask(e.target.value);

        this.setState({ julho: dmm });
        this.calcularTotal(dmm, 7);

    }

    changeAgosto(e) {

        /*let re = /^-?[0-9]*(,[0-9]{0,2})?$/i;

        if (re.test(e.target.value)) {
            this.setState({ agosto: e.target.value });
            this.calcularTotal(e.target.value, 8);
        }*/

        let dmm = this.dynamicMoneyMask(e.target.value);

        this.setState({ agosto: dmm });
        this.calcularTotal(dmm, 8);

    }

    changeSetembro(e) {

        /*let re = /^-?[0-9]*(,[0-9]{0,2})?$/i;

        if (re.test(e.target.value)) {
            this.setState({ setembro: e.target.value });
            this.calcularTotal(e.target.value, 9);
        }*/

        let dmm = this.dynamicMoneyMask(e.target.value);

        this.setState({ setembro: dmm });
        this.calcularTotal(dmm, 9);

    }

    changeOutubro(e) {

        /*let re = /^-?[0-9]*(,[0-9]{0,2})?$/i;

        if (re.test(e.target.value)) {
            this.setState({ outubro: e.target.value });
            this.calcularTotal(e.target.value, 10);
        }*/

        let dmm = this.dynamicMoneyMask(e.target.value);

        this.setState({ outubro: dmm });
        this.calcularTotal(dmm, 10);

    }

    changeNovembro(e) {

        /*let re = /^-?[0-9]*(,[0-9]{0,2})?$/i;

        if (re.test(e.target.value)) {
            this.setState({ novembro: e.target.value });
            this.calcularTotal(e.target.value, 11);
        }*/

        let dmm = this.dynamicMoneyMask(e.target.value);

        this.setState({ novembro: dmm });
        this.calcularTotal(dmm, 11);

    }

    changeDezembro(e) {

        /*let re = /^-?[0-9]*(,[0-9]{0,2})?$/i;

        if (re.test(e.target.value)) {
            this.setState({ dezembro: e.target.value });
            this.calcularTotal(e.target.value, 12);
        }*/

        let dmm = this.dynamicMoneyMask(e.target.value);

        this.setState({ dezembro: dmm });
        this.calcularTotal(dmm, 12);

    }

    changeComentario(e) {
        this.setState({ comentario: e.target.value });
    }

    calcularTotal(valor, mes) {

        let total = 0;

        if (valor !== "") {
            total += parseFloat(this.moneyUnmask(valor));
        }

        if (this.state.janeiro !== "" && mes !== 1) {
            total += parseFloat(this.moneyUnmask(this.state.janeiro));
        }

        if (this.state.fevereiro !== "" && mes !== 2) {
            total += parseFloat(this.moneyUnmask(this.state.fevereiro));
        }

        if (this.state.marco !== "" && mes !== 3) {
            total += parseFloat(this.moneyUnmask(this.state.marco));
        }

        if (this.state.abril !== "" && mes !== 4) {
            total += parseFloat(this.moneyUnmask(this.state.abril));
        }

        if (this.state.maio !== "" && mes !== 5) {
            total += parseFloat(this.moneyUnmask(this.state.maio));
        }

        if (this.state.junho !== "" && mes !== 6) {
            total += parseFloat(this.moneyUnmask(this.state.junho));
        }

        if (this.state.julho !== "" && mes !== 7) {
            total += parseFloat(this.moneyUnmask(this.state.julho));
        }

        if (this.state.agosto !== "" && mes !== 8) {
            total += parseFloat(this.moneyUnmask(this.state.agosto));
        }

        if (this.state.setembro !== "" && mes !== 9) {
            total += parseFloat(this.moneyUnmask(this.state.setembro));
        }

        if (this.state.outubro !== "" && mes !== 10) {
            total += parseFloat(this.moneyUnmask(this.state.outubro));
        }

        if (this.state.novembro !== "" && mes !== 11) {
            total += parseFloat(this.moneyUnmask(this.state.novembro));
        }

        if (this.state.dezembro !== "" && mes !== 12) {
            total += parseFloat(this.moneyUnmask(this.state.dezembro));
        }

        this.setState({ total: this.moneyMask(total.toString()) });

    }

    cadastrar() {

        if (this.state.ano === "") {

            this.props.errMsgHandler("Por favor, informe o ano do orçamento.");

        } else {

            this.props.errMsgHandler("");
            this.setState({ conf: true }); 

        }

    }

    cancelar() {

        let obj = {
            id: this.state.id,
            codConta: this.state.codConta,
            conta: this.state.conta,
            tipoConta: this.state.tipoContaNome,
            tipoContaId: this.state.tipoConta,
            naturezaConta: this.state.naturezaConta,
            cultura: this.state.cultura,
            centroId: this.state.centroId,
            centro: this.state.centro
        };

        this.props.history.push({
            pathname: "/orcamento",
            state: obj
        });

    }

    voltar() {
        this.setState({ conf: false });
    }

    confirmar() {

        this.setState({ disabled: true });
        this.props.waitMsgHandler("Aguardando");

        let obj = {
            ano: this.state.ano,
            janeiro: null,
            fevereiro: null,
            marco: null,
            abril: null,
            maio: null,
            junho: null,
            julho: null,
            agosto: null,
            setembro: null,
            outubro: null,
            novembro: null,
            dezembro: null,
            comentario: this.state.comentario,
            conta_id: this.state.id
        };

        if (this.state.janeiro !== "0,00") obj.janeiro = this.moneyUnmask(this.state.janeiro);
        if (this.state.fevereiro !== "0,00") obj.fevereiro = this.moneyUnmask(this.state.fevereiro);
        if (this.state.marco !== "0,00") obj.marco = this.moneyUnmask(this.state.marco);
        if (this.state.abril !== "0,00") obj.abril = this.moneyUnmask(this.state.abril);
        if (this.state.maio !== "0,00") obj.maio = this.moneyUnmask(this.state.maio);
        if (this.state.junho !== "0,00") obj.junho = this.moneyUnmask(this.state.junho);
        if (this.state.julho !== "0,00") obj.julho = this.moneyUnmask(this.state.julho);
        if (this.state.agosto !== "0,00") obj.agosto = this.moneyUnmask(this.state.agosto);
        if (this.state.setembro !== "0,00") obj.setembro = this.moneyUnmask(this.state.setembro);
        if (this.state.outubro !== "0,00") obj.outubro = this.moneyUnmask(this.state.outubro);
        if (this.state.novembro !== "0,00") obj.novembro = this.moneyUnmask(this.state.novembro);
        if (this.state.dezembro !== "0,00") obj.dezembro = this.moneyUnmask(this.state.dezembro);

        fetch("/api/orcamento/", {
            method: "POST",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors",
            body: JSON.stringify(obj)
        })
        .then(response => response.json())
        .then(responseJson => {

            if (responseJson.msg === "success") {

                this.props.waitMsgHandler("");
                this.props.successMsgHandler("Orçamento cadastrado com sucesso.");

                let obj2 = {
                    id: this.state.id,
                    codConta: this.state.codConta,
                    conta: this.state.conta,
                    tipoConta: this.state.tipoContaNome,
                    tipoContaId: this.state.tipoConta,
                    naturezaConta: this.state.naturezaConta,
                    cultura: this.state.cultura,
                    centroId: this.state.centroId,
                    centro: this.state.centro
                };

                this.props.history.push({
                    pathname: "/orcamento",
                    state: obj2
                });

            } else {

                this.props.waitMsgHandler("");
                this.props.errMsgHandler(responseJson.msg);
                this.setState({ disabled: false });

            }

        });

    }

    componentDidMount() {

        if (localStorage.roleContas !== "escrever") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/contas";
        }

        let centroId = this.props.location.state.centroId;
        let centro = this.props.location.state.centro;
        let id = this.props.location.state.id;
        let codConta = this.props.location.state.codConta;
        let conta = this.props.location.state.conta;
        let tipoContaNome = this.props.location.state.tipoConta;
        let tipoConta = this.props.location.state.tipoContaId;
        let naturezaConta = this.props.location.state.naturezaConta;
        let cultura = this.props.location.state.cultura;

        this.setState({ centroId: centroId });
        this.setState({ centro: centro });
        this.setState({ id: id });
        this.setState({ codConta: codConta });
        this.setState({ conta: conta });
        this.setState({ tipoConta: tipoConta });
        this.setState({ tipoContaNome: tipoContaNome });
        this.setState({ naturezaConta: naturezaConta });
        this.setState({ cultura: cultura });

    }

    render() {
        return(
            <div>
                <h1 id="cadastrar-orcamento-title">Cadastrar Novo Orçamento</h1><br />
                <br />
                <p id="cadastrar-orcamento-centro">
                    <b>Centro: </b> { this.state.centro }
                </p><br />
                <p id="cadastrar-orcamento-conta">
                    <b>Conta: </b> { this.state.conta }
                </p><br />
                { this.state.conf === false &&
                    <CadastrarOrcamentoForm
                        ano={ this.state.ano }
                        changeAno= { this.changeAno }
                        janeiro={ this.state.janeiro }
                        changeJaneiro={ this.changeJaneiro }
                        fevereiro={ this.state.fevereiro }
                        changeFevereiro={ this.changeFevereiro }
                        marco={ this.state.marco }
                        changeMarco={ this.changeMarco }
                        abril={ this.state.abril }
                        changeAbril={ this.changeAbril }
                        maio={ this.state.maio }
                        changeMaio={ this.changeMaio }
                        junho={ this.state.junho }
                        changeJunho={ this.changeJunho }
                        julho={ this.state.julho }
                        changeJulho={ this.changeJulho }
                        agosto={ this.state.agosto }
                        changeAgosto={ this.changeAgosto }
                        setembro={ this.state.setembro }
                        changeSetembro={ this.changeSetembro }
                        outubro={ this.state.outubro }
                        changeOutubro={ this.changeOutubro }
                        novembro={ this.state.novembro }
                        changeNovembro={ this.changeNovembro }
                        dezembro={ this.state.dezembro }
                        changeDezembro={ this.changeDezembro }
                        comentario={ this.state.comentario }
                        changeComentario={ this.changeComentario }
                        total={ this.state.total }
                        cadastrar={ this.cadastrar }
                        cancelar={ this.cancelar } /> }
                { this.state.conf === true &&
                    <CadastrarOrcamentoConf
                        ano={ this.state.ano }
                        janeiro={ this.state.janeiro }
                        fevereiro={ this.state.fevereiro }
                        marco={ this.state.marco }
                        abril={ this.state.abril }
                        maio={ this.state.maio }
                        junho={ this.state.junho }
                        julho={ this.state.julho }
                        agosto={ this.state.agosto }
                        setembro={ this.state.setembro }
                        outubro={ this.state.outubro }
                        novembro={ this.state.novembro }
                        dezembro={ this.state.dezembro }
                        comentario={ this.state.comentario }
                        total={ this.state.total }
                        voltar={ this.voltar }
                        confirmar={ this.confirmar }
                        disabled={ this.state.disabled } /> }
            </div>
        );
    }

}

export default withRouter(CadastrarOrcamento);

